module.exports = __webpack_public_path__ + "img/icon-arrow-right.6c2b1658.svg";